import React from 'react';
import { ChevronDown, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Card } from '@/components/ui';
import { AnimatedCollapse } from '@/components/ui/animated-collapse';

interface ConfigSectionProps {
  title: string;
  description: string;
  icon: LucideIcon;
  iconClassName?: string;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  children: React.ReactNode;
}

export const ConfigSection: React.FC<ConfigSectionProps> = ({
  title,
  description,
  icon: Icon,
  iconClassName,
  isOpen,
  onOpenChange,
  children,
}) => {
  return (
    <div>
      <button
        type="button"
        onClick={() => onOpenChange(!isOpen)}
        aria-expanded={isOpen}
        className="w-full text-left group touch-target py-2"
      >
        <div className="flex items-center gap-2">
          <Icon className={cn("h-4 w-4 text-primary", iconClassName)} />
          <span
            role="heading"
            aria-level={4}
            className="text-sm heading-label text-foreground group-hover:text-foreground/80 transition-colors"
          >
            {title}
          </span>
          <ChevronDown
            className={cn(
              "h-4 w-4 text-muted-foreground transition-transform duration-200",
              isOpen && "rotate-180"
            )}
          />
        </div>
        <p className="text-xs text-muted-foreground text-left">{description}</p>
      </button>

      <AnimatedCollapse open={isOpen}>
        <Card variant="outlined" className="mt-3 !p-4 bg-transparent">
          {children}
        </Card>
      </AnimatedCollapse>
    </div>
  );
};
